<template>
  <div class="container-fluid">
    <p class="fs-5">
      {{ $t('modal.titleInfoDelete') }}
    </p>

    <b-button class="float-end" 
      variant="danger"
              :disabled="db"
      @click="onClick"
    >
      {{ $t('modal.button.delete') }}
    </b-button>

    <b-button class="float-end me-3" 
      variant="warning" 
      @click="onClose"
    >
      {{ $t('modal.button.back') }}
    </b-button>
  </div>
</template>

<script>
  import { deleteManagerWaterRound } from '../../../../api/endpoints/managerWaterRound';

  export default {
    name: "ClientsDeleteModal",
    props: {
      id: {
        type: Number,
      }
    },
    data() {
      return {
        db: false,
      }
    },
    methods: {
      onClick() {
        this.db = true;
        setTimeout(() => {
          this.db = false;
        }, 700)
        deleteManagerWaterRound(this.id).then( () => {
          this.onClose()
        })
      },
      onClose() {
        this.$emit('onClose')
      }
    }
  }
</script>